import styled from "styled-components";


export const StyledForbiddenContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    svg{
        height: 60px;
        width: 60px;
        fill: var(--primary-button-bg);
    }
    button{
        width:250px;
        margin-top:1rem;
    }
`
export const Message = styled.div`
  text-align: center;
  h1 {
    margin: 40px 0 20px;
    color: #333;
  }

  p {
    color: #555;
  }
`;